<div *ngIf="license">
  <h2>Current license</h2>
  <ul>
    <li>
      <span class="attribute">Type</span> :
      <span class="value">{{ this.license.type.name }}</span>
    </li>
    <li>
      <span class="attribute">Uses remaining</span> :
      <span
        [ngClass]="{
          value: license.usesRemaining > 20,
          careful: license.usesRemaining <= 20
        }"
        *ngIf="license.usesRemaining > 0"
        >{{ this.license.usesRemaining }}
        <fa-icon
          [icon]="faWarning"
          *ngIf="license.usesRemaining <= 20"
          matTooltip="You are approching your uses limit"
        ></fa-icon>
      </span>
      <span class="warn" *ngIf="license.usesRemaining <= 0"
        >No more uses
        <fa-icon
          [icon]="faWarning"
          matTooltip="You have used all your calls"
        ></fa-icon>
      </span>
      <span class="value" *ngIf="license.type.name == 'Unlimited'"
        >No limit</span
      >
    </li>
    <li *ngIf="license.expiryDate != null">
      <span class="attribute">Expiry date</span> :
      <span
        [ngClass]="{
          value: license.status.name == 'Active' && !dateBefore2weeks,
          careful: license.status.name == 'Active' && dateBefore2weeks,
          warn: license.status.name == 'Expired'
        }"
        >{{ this.license.expiryDate | date : "shortDate" }}
        <fa-icon
          [icon]="faWarning"
          *ngIf="license.status.name == 'Expired'"
          matTooltip="Your license has expired"
        ></fa-icon>
        <fa-icon
          [icon]="faWarning"
          *ngIf="license.status.name == 'Active' && dateBefore2weeks"
          matTooltip="Your license will expire in a few days"
        ></fa-icon>
      </span>
    </li>
    <li *ngIf="license.expiryDate == null">
      <span class="attribute">No expiry date</span>
    </li>
  </ul>
</div>
<p *ngIf="!license" class="warn">
  No license
  <fa-icon
    [icon]="faWarning"
    matTooltip="You can use ANPR tool only if you have a license"
  ></fa-icon>
</p>
